import { Pipe, PipeTransform } from '@angular/core';
import { InspectionInfoPluginService } from './inspectionInfo-plugin.service';

@Pipe({
    name: 'inspectiontype',
    standalone: false
})
export class InspectionTypePipe implements PipeTransform {
  public types: any;

  constructor(private service: InspectionInfoPluginService) {
    this.types = this.service.getAllTypes();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.types);
  }
}
